import React, { useContext } from 'react';
import SearchContext from 'contexts/SearchContext';
import { resetParameters } from 'contexts/SearchActions';
import { X } from 'react-feather';

const ClearAllFiltersButton = () => {
    const { dispatch } = useContext(SearchContext);

    return (
        <button
            onClick={() => resetParameters(dispatch)}
            className="py-1 pl-1 pr-2 flex gap-1 text-sm items-center rounded-full border border-transparent hover:border-black"
        >
            <X height={19} /> <span>Počisti filtre</span>
        </button>
    );
};

export default ClearAllFiltersButton;
